import { __assign } from "tslib";
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Confirmation, OrderSummary, ProgressBar } from './components';
import { Details } from './steps/details/Details';
import { DetailsOfficeworks } from './steps/details/DetailsOfficeworks';
import { SelectHardwareOfficeworks, SelectHardwareTOM, SelectHardwareEA, SelectHardwareAldi, SelectHardwareIspx, SelectHardware, } from './steps/hardware';
import { Payment } from './steps/payment/Payment';
import { TermsConditions } from './steps/terms/TermsConditions';
import { SelectPlan, SelectPlanEA, SelectPlanBDF, SelectPlanOfficeworks, SelectPlanAldi, SelectPlanIspx, SelectPlanPronto, SelectPlanCTL, } from './steps/plan';
import { ConnectionDetails } from './steps/connectionDetails';
var Signup = inject('appStore', 'config')(observer(function (props) {
    var _a = React.useState({
        currentStep: props.appStore.currentStep,
    }), state = _a[0], setstate = _a[1];
    React.useEffect(function () {
        if (state.currentStep !== props.appStore.currentStep) {
            setstate({
                currentStep: props.appStore.currentStep,
            });
            if (typeof 'window' !== 'undefined') {
                try {
                    window.scroll({
                        behavior: 'smooth',
                        left: 0,
                        top: 0,
                    });
                }
                catch (error) {
                    window.scrollTo(0, 0);
                }
            }
        }
    });
    var currentStep = state.currentStep;
    var wholesaleCustomerCode = props.config.wholesaleCustomerCode;
    var progressBarProps = {
        currentStep: currentStep,
        pageTitles: [
            'Plan',
            'Connection Details',
            'Hardware',
            'Details',
            'T&Cs',
            'Secure Payment',
            'Confirmation',
        ],
    };
    function planSelection(CustomerCode) {
        switch (CustomerCode) {
            case 'OT':
                return React.createElement(SelectPlanOfficeworks, null);
            case 'EA':
                return React.createElement(SelectPlanEA, null);
            case 'BDF':
                return React.createElement(SelectPlanBDF, null);
            case 'ALDI':
                return React.createElement(SelectPlanAldi, null);
            case 'ISPX':
                return React.createElement(SelectPlanIspx, null);
            case 'PB':
                return React.createElement(SelectPlanPronto, null);
            case 'CTL':
                return React.createElement(SelectPlanCTL, null);
            default:
                return React.createElement(SelectPlan, null);
        }
    }
    function harwareSelection(CustomerCode) {
        switch (CustomerCode) {
            case 'OT':
            case 'PB':
                return React.createElement(SelectHardwareOfficeworks, null);
            case 'EA':
                return React.createElement(SelectHardwareEA, null);
            case 'TOM':
                return React.createElement(SelectHardwareTOM, null);
            case 'ALDI':
                return React.createElement(SelectHardwareAldi, null);
            case 'ISPX':
                return React.createElement(SelectHardwareIspx, null);
            default:
                return React.createElement(SelectHardware, null);
        }
    }
    function detailsByWholesaler(CustomerCode) {
        switch (CustomerCode) {
            case 'OT':
                return React.createElement(DetailsOfficeworks, null);
            default:
                return React.createElement(Details, null);
        }
    }
    function paymentNameSelectionByWholeSaler(CustomerCode) {
        switch (CustomerCode) {
            case 'EA':
                return 'Credit Card Payment Authority';
            default:
                return 'Secure payment';
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ProgressBar, __assign({}, progressBarProps)),
        React.createElement("div", { className: "step-progress" },
            React.createElement("h2", { className: "page-title" },
                React.createElement("span", { className: "gradient" }, {
                    0: 'Select Plan',
                    1: 'Connection Details',
                    2: 'Select hardware',
                    3: 'Your details',
                    4: 'Terms and conditions',
                    5: paymentNameSelectionByWholeSaler(wholesaleCustomerCode),
                    6: 'Congratulations',
                }[currentStep])),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-8" },
                    React.createElement("div", { className: "panel", style: { marginBottom: '1rem' } }, {
                        0: planSelection(wholesaleCustomerCode),
                        1: React.createElement(ConnectionDetails, null),
                        2: harwareSelection(wholesaleCustomerCode),
                        3: detailsByWholesaler(wholesaleCustomerCode),
                        4: React.createElement(TermsConditions, null),
                        5: React.createElement(Payment, null),
                        6: React.createElement(Confirmation, null),
                    }[currentStep])),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement(OrderSummary, null))))));
}));
export default Signup;
//# sourceMappingURL=index.js.map